export async function getData(fileName) {
    const data = await fetch(`data/${fileName}`);
    const json = await data.json();
    return json.data;
}
